<template>
  <div class="ksm-map__wrapper">
    <div class="ksm-map__page">
      <div ref="map-container" class="ksm-map__container"></div>
      <div class="ksm_map_infobox_container ksm-display-none">
        <template v-for="fensterData of fensterDataCollection">
          <div
            class="ksm-map__fenster"
            :class="(!fensterData.visible && (fensterData.infoItem?!fensterData.infoItem.fixied:true)) || (fensterData.type==='ortsFenster' && fensterData.infoItems.length<1)?'ksm-display-none':''"
            @mousedown="fensterMouseDown(fensterData, $event)"
            :key="fensterData.type+'_'+fensterData.stadtindex"
            :data-stadtindex="fensterData.type+'_'+fensterData.stadtindex"
          >
            <div class="ksm-map__fenster-header">
              <div class="ksm-flex-y-center">
                <div
                  v-if="fensterData.infoItem"
                  class="ksm-map__fenster-item-icon"
                  :style="'background-color:'+ fensterData.infoItem.accor.color"
                ></div>
                <div class="ksm-map__fenster-title">{{fensterData.stadtname}}</div>
              </div>
              <div class="ksm-flex">
                <div
                  v-if="fensterData.type==='infoFenster'"
                  class="ksm-flex-y-center"
                  style="padding:5px"
                >
                  <div
                    v-html="$_getSvg('arrow-left-2.svg')"
                    @click="navigatorInfoFenster(fensterData,-1)"
                    class="ksm-map__fenster-header-arror"
                  ></div>
                  <div
                    v-html="$_getSvg('arrow-right-2.svg')"
                    @click="navigatorInfoFenster(fensterData, 1)"
                    class="ksm-map__fenster-header-arror"
                  ></div>
                  <!-- <div style="width:20px; height:20px" @click="fixierenFenster(fensterData)" v-html="$_getSvg('fenster-fixieren.svg')"></div> -->
                </div>
                <div @click="closeFenster(fensterData)" class="ksm-map__fenster-close">x</div>
              </div>
            </div>
            <div class="ksm-map__fenster-body">
              <template v-if="fensterData.type==='ortsFenster'">
                <div
                  class="ksm-map__fenster-item"
                  v-for="(infoItem,j) of fensterData.infoItems"
                  :key="infoItem.row.docID+''+j"
                >
                  <div
                    class="ksm-map__fenster-item-icon"
                    :style="'background-color:'+ infoItem.accor.color"
                  ></div>
                  <a
                    style="color:#000"
                    @mousedown="startClick($event)"
                    @click="clickInfoItem(infoItem,$event)"
                  >{{infoItem.row._datvon}} {{infoItem.row.ortsname}}</a>
                </div>
              </template>
              <template v-if="fensterData.infoItem">
                <div class="ksm-flex-1">
                  <div
                    v-if="['Ausstellungen','Zeitschriften','Publikationen','Institution'].indexOf(fensterData.infoItem.row.Kategorie)>-1"
                  >{{fensterData.infoItem.row.titel}}</div>
                  <div v-else>{{fensterData.infoItem.row.ortsname}}</div>
                  <div>{{fensterData.infoItem.row.doc['113_titel']}}</div>
                  <div>{{fensterData.infoItem.row._datvon}}{{fensterData.infoItem.row._datbis?(' &ndash; '+fensterData.infoItem.row._datbis):''}}</div>
                  <div>{{fensterData.infoItem.row.doc['113_personen']?('Personen: '+fensterData.infoItem.row.doc['113_personen'].map(p=>p.content).join('; ')):''}}</div>
                  <div>{{fensterData.infoItem.row.doc['113_instutionen']?('Institutionen: '+fensterData.infoItem.row.doc['113_instutionen'].map(p=>p.content).join(', ')):''}}</div>
                  <div
                    v-html="fensterData.infoItem.row.full_113_html"
                    class="ksm-hyphens ksm-disable-select"
                    style="overflow:auto; margin-top:5px"
                  ></div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <div style="display:none">
          <div
            class="ksm-map__control-btn alle-ortsfenster-schliessen"
            title="Alle Ortsfenster schließen"
            v-html="$_getSvg('alle-ortsfenster-schliessen.svg')"
          ></div>
          <div
            class="ksm-map__control-btn alle-infofenster-schliessen"
            title="Alle Infofenster schließen"
            v-html="$_getSvg('alle-infofenster-schliessen.svg')"
          ></div>
        </div>
      </div>
    </div>
    <div class="ksm-map__timeline-wrapper" v-if="!option.hideTimeline">
      <div class="ksm-flex" style="justify-content:flex-end">
        <div style="width:220px; background-color:#eee; text-align:center; padding:0 5px">
          <a
            href="https://daeh.uni-trier.de/"
            target="_blank"
          >© Karte 1928 aus Digital Atlas of European Historiography</a>
        </div>
      </div>
      <TimelineView
        v-show="sidebarRightList[0].isExpand===true|| sidebarRightList[1].isExpand===true"
        :splitLayoutResize="option.splitLayoutResize"
        @clickInfoItem="clickInfoItem"
        :activeInfoItem="activeInfoItem"
        :infoItemList="timelineViewInput"
        @changeDate="changeDate"
      ></TimelineView>
    </div>
  </div>
</template>

<script>
require("ol/ol.css");
import OLMap from "ol/Map";
import View from "ol/View";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import FormatGeojson from "ol/format/GeoJSON";
import Overlay from "ol/Overlay.js";
import Point from "ol/geom/Point.js";
import {
  Circle as CircleStyle,
  Icon,
  Fill,
  Text,
  Stroke,
  Style
} from "ol/style";
import Circle from "ol/geom/Circle";
import { fromLonLat } from "ol/proj";
import { click, pointerMove, altKeyOnly } from "ol/events/condition.js";
import { defaults as defaultInteractions } from "ol/interaction.js";
import Select from "ol/interaction/Select.js";
import { LineString } from "ol/geom.js";
import Feature from "ol/Feature";
import { defaults as defaultControls, Control } from "ol/control.js";
import { getCenter } from "ol/extent.js";
import { mapGetters } from "vuex";

// import Drag from "comps/MapDrag";

import Vue from "vue";
import * as d3 from "d3";
import TimelineView from "./Timeline.vue";
// import TimelineView from "./TimelineView.vue";

export default {
  props: { geoData: Object, option: Object },
  data() {
    return {
      stadtFilterIds: null,
      map: null,
      fixierendItems: [],
      currentInfobox: null,
      hoveringFeature: null,
      centerCity: "Jena",
      fensterZIndex: 1,
      tourLineLayer: null,
      baseLayer: null
    };
  },
  components: {
    TimelineView
  },
  created: function() {
    this.$store
      .dispatch("orteundwege/prepareAllfensterDataCollection")
      .then(data => {});
  },

  mounted() {
    const vue = this;
    this.initMap();
    this.setMapExtent();
    vue.$el.addEventListener("resize", function() {
      vue.map.updateSize();
    });
  },

  watch: {
    stadtFilterIds() {
      this.updatePiechartLayer();
    },

    activeInfoItem(infoItem) {
      if (!infoItem) {
        return;
      }
      const vue = this;
      const feature = this.getFeatureByRow(infoItem.row);
      if (feature) {
        this.flyTo(feature.getGeometry().getCoordinates(), function() {
          vue.openInfoFenster(infoItem);
          vue.drawTourplan(infoItem);
        });
      }
    },

    sidebarRightList: {
      handler: function(d) {
        this.updatePiechartLayer();
        this.$store
          .dispatch("orteundwege/updateAllOrtsFensterData")
          .then(res => {
            this.resetAllInboxLine();
          });
      },
      deep: true
    },
    filterMerzgebieteGeoData: {
      handler: function() {
        this.updateMerzgebieteLayer();
      },
      deep: true
    }
  },

  methods: {
    changeDate(ids) {
      this.stadtFilterIds = ids;
    },

    setMapExtent() {
      const map = this.map;
      const extent = map.getView().calculateExtent(map.getSize());
    },

    createPiechartStyle(img, imgSize) {
      const iconStyle = new Style({
        image: new Icon({
          img: img,
          imgSize: imgSize
        })
      });
      return iconStyle;
    },

    createMapLayer() {
      const layer = new TileLayer({
        source: new XYZ({
          crossOrigin: "anonymous",
          url: "static/map_tiles/background/world/{z}/{x}/{y}" + ".png",
          maxZoom: 8,
          tilePixelRatio: 2,
          tileSize: [512, 512]
          // url: "static/ttt/{z}/{x}/{-y}" + ".png"
        })
      });
      this.baseLayer = layer;
      return layer;
    },

    createRetinaLayer() {
      const layer = new TileLayer({
        source: new XYZ({
          crossOrigin: "anonymous",
          url: "static/map_tiles/retina/{z}/{x}/{-y}" + ".png",
          maxZoom: 8,
          tilePixelRatio: 2,
          tileSize: [512, 512]
        })
      });
      this.baseLayer = layer;
      return layer;
    },

    createCityLayer() {
      const vue = this;

      const layer = new VectorLayer({
        declutter: true,
        style: function(feature, resolution) {
            return new Style({
              geometry: new Circle(feature.getGeometry().getCoordinates(), 2 * resolution),
              fill: new Fill({ color: "#000" }),
              stroke: new Stroke({ color: "#000", width: 1 }),
              text:  new Text({
              textAlign: "left",
              offsetX: 12,
              font: "12px Arial, Helvetica, sans-serif, Verdana",
              fill: new Fill({
                color: "#222"
              }),
              text: feature.get("stadtname")
            }),
          });
        }
      });
      this.cityLayer = layer;
      // this.updateCityLayer();
      return layer;
    },

    createPiechartLayer() {
      const vue = this;
      const piechartLayer = new VectorLayer({
        style: function(feature) {
          return vue.createPiechartStyle(
            feature.get("icon"),
            feature.get("iconSize")
          );
        }
      });
      this.piechartLayer = piechartLayer;
      this.updatePiechartLayer();
      return piechartLayer;
    },

    initMap() {
      const vue = this;
      const option = this.option;
      const zoom = option.zoom ? option.zoom : 5;
      // add layers
      let layers = [
        this.createMapLayer(),
        this.createRetinaLayer(),
        this.createCityLayer(),
        this.createMerzgebieteLayer()
      ];
      if (option && option.showPiechart) {
        layers.push(this.createPiechartLayer());
      }
      layers = layers.concat(this.createTourplanLayers());

      //create Map
      let center = this.geoData.features.find(
        f => f.properties.stadtname === vue.centerCity
      );
      if (!center) {
        center = this.geoData.features[0];
      }

      //controls
      const RotateNorthControl = (function(Control) {
        function RotateNorthControl(opt_options) {
          const options = opt_options || {};
          const element = document.createElement("div");
          element.className = "ksm-map__controls ol-unselectable";

          const ortsIcon = vue.$el.querySelector(
            ".alle-ortsfenster-schliessen"
          );
          element.appendChild(ortsIcon);

          const infoIcon = vue.$el.querySelector(
            ".alle-infofenster-schliessen"
          );
          element.appendChild(infoIcon);

          Control.call(this, {
            element: element,
            target: options.target
          });

          infoIcon.addEventListener(
            "click",
            function() {
              vue.closeAllFenster("infoFenster", { resetActiveInfoItem: true });
            },
            false
          );

          ortsIcon.addEventListener(
            "click",
            function() {
              vue.closeAllFenster("ortsFenster");
            },
            false
          );
        }

        if (Control) RotateNorthControl.__proto__ = Control;
        RotateNorthControl.prototype = Object.create(
          Control && Control.prototype
        );
        RotateNorthControl.prototype.constructor = RotateNorthControl;
        return RotateNorthControl;
      })(Control);

      let controls = [];
      if (option && option.showControls) {
        controls = defaultControls({
          attribution: false
        }).extend([new RotateNorthControl()]);
      }
      let centerPos = [0, 0];
      if (center) {
        centerPos = center.geometry.coordinates;
      }
      const map = new OLMap({
        target: vue.$refs["map-container"],
        controls: controls,
        layers: layers,
        view: new View({
          center: fromLonLat(centerPos, "EPSG:3857"),
          zoom: zoom,
          maxZoom: 8,
          minZoom: 3
          // pixelRatio: 2
        })
      });
      vue.map = map;

      document.addEventListener("mouseup", function() {
        vue.currentInfobox = null;
        vue.startMove = false;
      });

      map.on("singleclick", function(evt) {
        const hoveringFeature = vue.hoveringFeature;
        if (hoveringFeature) {
          vue.openFenster({
            feature: hoveringFeature,
            type: "ortsFenster"
          });
        }
      });

      //drag infobox / cursor
      map.on("pointermove", function(evt) {
        //move infobox
        vue.startMove = true;
        const currentInfobox = vue.currentInfobox;
        if (currentInfobox) {
          return vue.moveInfobox(vue, evt, currentInfobox);
        }

        //set mouse cursor / hover feature icon
        const features = map.getFeaturesAtPixel(evt.pixel);
        if (features && features.find(f => f.get("icon"))) {
          map.getTargetElement().style.cursor = "pointer";
          vue.hoverFetureIcon(features.find(f => f.get("icon")));
          //
        } else {
          if (vue.hoveringFeature) {
            vue.hoveringFeature.setStyle(null);
          }
          vue.hoveringFeature = null;
          map.getTargetElement().style.cursor = "";
        }
      });

      map.getView().on("change:resolution", () => {
        vue.resetAllInboxLine();
      });

      //emit inited
      vue.$emit("inited", map);
    },
    //inted end *************************************************************************************************

    fixierenFenster(fensterData) {
      fensterData.infoItem.fixied = true;
      this.fixierendItems.push(fensterData.infoItem);
    },
    //
    closeFenster(fensterData) {
      fensterData.visible = false;
      if (fensterData.type === "infoFenster") {
        this.clickInfoItem(null);
        fensterData.infoItem.fixied = false;
        this.refreshTourplanLayer();
      }
      this.refreshFensterLine(fensterData);
    },

    startClick(evt) {
      if (!evt) {
        return;
      }
      this.clickInfoItemTimestamp = evt.timeStamp;
    },

    clickInfoItem(infoItem, evt) {
      if (evt && evt.timeStamp - this.clickInfoItemTimestamp > 100) {
        return;
      }
      this.$store.commit("orteundwege/activeInfoItem", infoItem);
      if (infoItem) {
        this.$store.state.eventBus.$emit("ortundwege-accor-scroll", infoItem);
        this.$store.commit("orteundwege/expandAccor", infoItem.accor);
      }
    },
    navigatorInfoFenster(fensterData, to) {
      this.$store.commit("orteundwege/expandAccor", fensterData.infoItem.accor);
      this.$store.dispatch("orteundwege/navigatorInfoFenster", {
        infoItem: fensterData.infoItem,
        to: to
      });
    },

    closeAllFenster(type, opts) {
      const vue = this;
      this.fensterDataCollection
        .filter(fensterData => fensterData.type === type && fensterData.visible)
        .forEach(fensterData => {
          vue.closeFenster(fensterData);
        });
      if (type === "infoFenster") {
        if (opts && opts.resetActiveInfoItem) {
          this.$store.commit("orteundwege/activeInfoItem", null);
        }
        this.sidebarRightList.forEach(accor => {
          accor.infoItems.forEach(it => {
            it.fixied = false;
          });
        });
        vue.refreshTourplanLayer();
      }
    },

    refreshTourplanLayer() {
      const vue = this;
      vue.tourPunktLayer.setSource(null);
      vue.tourLineLayer.setSource(null);
    },

    //
    resetAllInboxLine() {
      this.fensterDataCollection.forEach(fensterData => {
        this.refreshFensterLine(fensterData);
      });
    },

    refreshFensterLine(fensterData) {
      if (!fensterData.lineFeature || !fensterData.lineLayer) {
        return;
      }
      if (
        (fensterData.infoItems &&
          fensterData.infoItems.length < 1 &&
          fensterData.type !== "infoFenster") ||
        (fensterData.visible === false &&
          (fensterData.infoItem ? !fensterData.infoItem.fixied : true))
      ) {
        fensterData.lineLayer.setVisible(false);
        return;
      } else {
        fensterData.lineLayer.setVisible(true);
      }
      const vue = this;
      const geometry = fensterData.lineFeature.getGeometry();
      const lineCoors = geometry.getCoordinates();
      geometry.setCoordinates([
        vue.getCenterOfOverlay(fensterData.overlay),
        lineCoors[1]
      ]);
    },

    moveInfobox(vue, evt, currentInfobox) {
      let { mouseClickPos, overlayCoordinate, fensterData } = currentInfobox;

      if (!mouseClickPos) {
        mouseClickPos = evt.coordinate;
        currentInfobox.mouseClickPos = mouseClickPos;
      }
      fensterData.position = [
        evt.coordinate[0] - mouseClickPos[0] + overlayCoordinate[0],
        evt.coordinate[1] - mouseClickPos[1] + overlayCoordinate[1]
      ];
      fensterData.overlay.setPosition(fensterData.position);
      vue.refreshFensterLine(fensterData);
    },

    getCenterOfOverlay(overlay) {
      const element = overlay.getElement();
      const [w, h] = [element.clientWidth, element.clientHeight];
      const map = this.map;
      const endPixel = map.getPixelFromCoordinate(overlay.getPosition());
      return map.getCoordinateFromPixel([
        endPixel[0] - w / 2,
        endPixel[1] + h / 2
      ]);
    },

    hoverFetureIcon(feature) {
      if (this.hoveringFeature) {
        this.hoveringFeature.setStyle(null);
      }
      const canvas = document.createElement("canvas");
      const image = feature.get("icon");
      const w = image.width + 8;
      const h = image.height + 8;
      const lineWidth = 2;
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, w, h);
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, (w - lineWidth) / 2, 0, 2 * Math.PI, false);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#fff";
      ctx.stroke();
      const style = this.createPiechartStyle(canvas, [w, h]);
      style.setText(
        new Text({
          textAlign: "left",
          offsetX: 20,
          font: "14px",
          fill: new Fill({
            color: "#000"
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 5
          }),
          text: feature.get("stadtname")
        })
      );
      style.setZIndex(10);
      feature.setStyle(style);
      this.hoveringFeature = feature;
    },

    fensterMouseDown(fensterData, evt) {
      if (evt.target.getAttribute("data-coordinates")) {
        return;
      }
      const vue = this;
      vue.fensterToTop(fensterData);
      vue.currentInfobox = {
        fensterData: fensterData,
        overlay: fensterData.overlay,
        overlayCoordinate: fensterData.overlay.getPosition(),
        mouseClickPos: null,
        lineFeature: fensterData.lineFeature
      };
    },

    getGeometryByOffset(geometry, offset) {
      const vue = this;
      const clone = geometry.clone();
      const [c0, c1] = clone.getCoordinates();
      const start = vue.map.getPixelFromCoordinate(c0);
      const end = vue.map.getPixelFromCoordinate(c1);
      let [x0, y0, x1, y1] = [start[0], start[1], end[0], end[1]];
      const dx = x1 - x0;
      const dy = y1 - y0;
      const dxy = Math.sqrt(dx * dx + dy * dy);
      if (dxy === 0) {
        return;
      }

      const _x0 = (offset / dxy) * dx + x0;
      const _x1 = x0 + ((dxy - offset) / dxy) * dx;
      const _y0 = (offset / dxy) * dy + y0;
      const _y1 = ((dxy - offset) / dxy) * dy + y0;

      const newStart = vue.map.getCoordinateFromPixel([_x0, _y0]);
      const newEnd = vue.map.getCoordinateFromPixel([_x1, _y1]);
      clone.setCoordinates([newStart, newEnd], "XY");
      return [clone, dxy];
    },

    createFensterOverlay(item, startPoint) {
      const vue = this;
      const stadtindex = item.stadtindex;
      const div = vue.$el
        .querySelector(".ksm_map_infobox_container")
        .querySelector(
          "[data-stadtindex='" + item.type + "_" + stadtindex + "']"
        );
      if (!div) {
        return;
      }
      var computedStyle = window.getComputedStyle(div, null);
      const pos = vue.map.getPixelFromCoordinate(startPoint);
      const overlay = new Overlay({
        element: div,
        id: stadtindex,
        positioning: "top-right",
        position: vue.map.getCoordinateFromPixel([
          pos[0] - div.clientWidth - 50,
          pos[1] - div.clientHeight - 50
        ])
      });
      vue.map.addOverlay(overlay);
      item.overlay = overlay;
      vue.fensterToTop(item);

      setTimeout(function() {
        //add line
        const lineFeature = vue.createLineFeature([
          vue.getCenterOfOverlay(overlay),
          startPoint
        ]);

        const lineLayer = new VectorLayer({
          source: new VectorSource({
            features: [lineFeature]
          }),
          style: new Style({
            stroke: new Stroke({
              width: 2,
              color: [0, 0, 0, 0.4]
            }),
            fill: new Fill({
              color: [0, 0, 0, 0.6]
            })
          })
        });
        item.lineFeature = lineFeature;
        item.lineLayer = lineLayer;
        vue.map.addLayer(lineLayer);
      }, 100);
    },

    createLineFeature(coor) {
      return new Feature(new LineString(coor));
    },

    setInfoItemTourData(infoItem) {
      const vue = this;
      const { accor, row } = infoItem;
      const infoItems = accor.infoItems;
      const idx = infoItems.indexOf(infoItem);

      const currentFeature = this.getFeatureByRow(row);
      if (!currentFeature) {
        console.log("kein Feature von ", row);
        return;
      }
      const currentCoordinates = currentFeature.getGeometry().getCoordinates();

      const lineFeatures = [];
      const punkte = [currentFeature];
      const stadtindex = currentFeature.get("stadtindex");
      if (idx > 0) {
        const preFeature = this.getFeatureByRow(infoItems[idx - 1].row);
        if (preFeature && preFeature.get("stadtindex") !== stadtindex) {
          const preCoor = preFeature.getGeometry().getCoordinates();
          punkte.push(preFeature);
          lineFeatures.push(
            vue.createLineFeature([preCoor, currentCoordinates])
          );
        }
      }
      if (idx < infoItems.length - 1) {
        const nextFeature = this.getFeatureByRow(infoItems[idx + 1].row);
        if (nextFeature && nextFeature.get("stadtindex") !== stadtindex) {
          const nextCoor = nextFeature.getGeometry().getCoordinates();
          punkte.push(nextFeature);
          lineFeatures.push(
            vue.createLineFeature([currentCoordinates, nextCoor])
          );
        }
      }
      return [punkte, lineFeatures];
    },

    drawTourplan(infoItem) {
      const vue = this;
      const activeAccordion = this.sidebarRightList.find(it => it.isExpand);
      const isHolland = activeAccordion.id === "holland";

      let lineFeatures = [];
      let punkte = [];
      const accor = infoItem.accor;

      vue.fixierendItems.concat(infoItem).forEach(infoItem => {
        const { accor, row } = infoItem;
        const infoItems = accor.infoItems;
        const idx = infoItems.indexOf(infoItem);

        const currentFeature = this.getFeatureByRow(row);
        if (!currentFeature) {
          console.log("kein Feature von ", row);
          return;
        }
        const currentCoordinates = currentFeature
          .getGeometry()
          .getCoordinates();
        punkte.push(currentFeature);
        const stadtindex = currentFeature.get("stadtindex");

        if (isHolland && idx > 0) {
          const preFeature = this.getFeatureByRow(infoItems[idx - 1].row);
          if (preFeature && preFeature.get("stadtindex") !== stadtindex) {
            const preCoor = preFeature.getGeometry().getCoordinates();
            punkte.push(preFeature);
            lineFeatures.push(
              vue.createLineFeature([preCoor, currentCoordinates])
            );
          }
        }
        if (isHolland && idx < infoItems.length - 1) {
          const nextFeature = this.getFeatureByRow(infoItems[idx + 1].row);
          if (nextFeature && nextFeature.get("stadtindex") !== stadtindex) {
            const nextCoor = nextFeature.getGeometry().getCoordinates();
            punkte.push(nextFeature);
            lineFeatures.push(
              vue.createLineFeature([currentCoordinates, nextCoor])
            );
          }
        }
      });
      punkte = [...new Set(punkte)];
      lineFeatures = [...new Set(lineFeatures)];

      // const punkte=[],lineFeatures=[];
      // vue.fixierendItems.concat(infoItem).forEach(it=>{
      //   const tourData=vue.setInfoItemTourData(it);
      //   punkte.push(tourData[0]);
      //   lineFeatures.push(tourData[1]);
      // });

      //add circle;
      const punktStyleFunc = function(feature) {
        const styles = [];
        styles.push(
          new Style({
            geometry: feature.getGeometry(),
            image: new Icon({
              img: vue.createCanvasCircle({
                w: 30,
                h: 30,
                lineWidth: 3,
                color: accor.color
              }),
              imgSize: [30, 30]
            })
          })
        );
        return styles;
      };

      //draw punkte
      vue.tourPunktLayer.setSource(
        new VectorSource({
          features: punkte
        })
      );
      vue.tourPunktLayer.setStyle(punktStyleFunc);

      //draw line
      vue.tourLineLayer.setSource(
        new VectorSource({
          features: lineFeatures
        })
      );
      const lineStyleFunc = function(feature) {
        const geometry = feature.getGeometry();
        const [clone, cxy] = vue.getGeometryByOffset(geometry, 15);
        // linestring
        const styles = [];

        if (clone && lineFeatures.length > 0) {
          styles.push(
            new Style({
              geometry: clone,
              stroke: new Stroke({
                color: accor.color,
                width: 3
              })
            })
          );
        }

        //arrow
        geometry.forEachSegment(function(start, end) {
          const dx = end[0] - start[0];
          const dy = end[1] - start[1];
          const rotation = Math.atan2(dy, dx);

          // arrows
          if (dx !== dy && cxy > 25) {
            styles.push(
              new Style({
                geometry: new Point(end),
                image: new Icon({
                  img: vue.createCanvasTriangle({
                    w: 15,
                    h: 15,
                    color: accor.color
                  }),
                  anchor: [1.7, 0.5],
                  imgSize: [15, 15],
                  rotateWithView: true,
                  rotation: -rotation
                })
              })
            );
          }
        });
        return styles;
      };
      vue.tourLineLayer.setStyle(lineStyleFunc);
    },

    //punkte und line layers
    createTourplanLayers() {
      const [tourLineLayer, tourPunktLayer] = [
        new VectorLayer(),
        new VectorLayer()
      ];
      this.tourPunktLayer = tourPunktLayer;
      this.tourLineLayer = tourLineLayer;
      return [tourLineLayer, tourPunktLayer];
    },

    createCanvasCircle({ w, h, color, lineWidth }) {
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, (w - lineWidth) / 2, 0, 2 * Math.PI, false);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = color;
      ctx.stroke();
      return canvas;
    },

    createCanvasCircleGradient({ w, h, color, lineWidth }) {
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.beginPath();
      const grad = ctx.createRadialGradient(
        w / 2,
        h / 2,
        0,
        w / 2,
        h / 2,
        w / 2
      );
      grad.addColorStop(0, color);
      grad.addColorStop(0.3, color);
      grad.addColorStop(1, "transparent");
      ctx.arc(w / 2, h / 2, w / 2, 0, 2 * Math.PI, false);
      ctx.fillStyle = grad;
      ctx.globalAlpha = 0.55;
      ctx.fill();

      // ctx.lineWidth = lineWidth;
      // ctx.strokeStyle = color;
      // ctx.stroke();
      return canvas;
    },

    createCanvasTriangle({ w, h, color }) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(w, h / 2);
      ctx.lineTo(0, h);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.closePath();
      return canvas;
    },

    getFeatureByRow(row) {
      const stadtindex = row.stadtindex || row.ortsindex;
      return this.cityLayer
        .getSource()
        .getFeatures()
        .find(f => {
          return stadtindex.split("#").indexOf(f.get("stadtindex")) > -1;
        });
    },

    openInfoFenster(infoItem) {
      console.log(infoItem)
      const { accor, row } = infoItem;
      const vue = this;
      const stadtindex = row.stadtindex || row.ortsindex;
      const feature = vue.getFeatureByRow(row);
      if (!feature) {
        return;
      }

      //
      vue.fensterDataCollection
        .filter(
          fensterData =>
            fensterData.type === "infoFenster" && fensterData.visible
        )
        .forEach(fensterData => {
          fensterData.visible = false;
          vue.refreshFensterLine(fensterData); //andere line schließen
        });

      vue.refreshTourplanLayer();
      vue.openFenster({
        feature: feature,
        type: "infoFenster",
        infoItem: infoItem
      });
    },

    openFenster({ feature, type, infoItem }) {
      const vue = this;
      const stadtindex = feature.get("stadtindex");
      const fensterData = this.fensterDataCollection.find(
        fensterData =>
          fensterData.stadtindex === stadtindex && fensterData.type === type
      );
      fensterData.visible = true;
      fensterData.infoItem = infoItem;

      if (!fensterData.infoItems && type === "ortsFenster") {
        vue.$store.commit(
          "orteundwege/updateOrtsFensterInfoItems",
          fensterData
        );
      }

      if (!fensterData.overlay) {
        vue.createFensterOverlay(
          fensterData,
          feature.getGeometry().getCoordinates()
        );
      } else {
        fensterData.visible = true;
        vue.fensterToTop(fensterData);
        if (
          (fensterData.infoItems && fensterData.infoItems.length < 1) ||
          fensterData.visible === false
        ) {
          fensterData.lineLayer.setVisible(false);
        } else {
          fensterData.lineLayer.setVisible(true);
        }
      }

      if (fensterData.type === "infoFenster") {
        const lastActiveInfoItem = this.$store.state.orteundwege.data
          .lastActiveInfoItem;
        if (lastActiveInfoItem) {
          const lastFensterData = this.fensterDataCollection.find(
            fensterData => fensterData.infoItem === lastActiveInfoItem
          );
          if (lastFensterData) {
            fensterData.overlay.setPosition(
              lastFensterData.overlay.getPosition()
            );
            vue.refreshFensterLine(fensterData);
          }
        }
      }
    },

    createMerzgebieteLayer() {
      const vue = this;
      const merzgebieteLayer = new VectorLayer({
        style: function(feature) {
          const canvas = vue.createCanvasCircleGradient({
            w: 50,
            h: 50,
            lineWidth: 2,
            color: feature.get("color")
          });

          return new Style({
            image: new Icon({
              img: canvas,
              imgSize: [60, 60]
            })
            // ,
            // text: new Text({
            //   textAlign: "left",
            //   offsetX: 20,
            //   font: "12px",
            //   fill: new Fill({
            //     color: "#111"
            //   }),
            //   text: feature.get("name")
            // }
            // )
          });
        }
      });
      this.merzgebieteLayer = merzgebieteLayer;
      this.updateMerzgebieteLayer();
      return merzgebieteLayer;
    },

    flyTo(location, done) {
      const view = this.map.getView();
      const duration = 500;
      let zoom = 5;
      let parts = 1;
      let called = false;
      function callback(complete) {
        --parts;
        if (called) {
          return;
        }
        if (parts === 0 || !complete) {
          called = true;
          done(complete);
        }
      }
      view.animate(
        {
          center: location,
          duration: duration
        },
        callback
      );
      // view.animate(
      //   {
      //     zoom: zoom - 1,
      //     duration: duration / 2
      //   },
      //   {
      //     zoom: zoom,
      //     duration: duration / 2
      //   },
      //   callback
      // );
    },

    updatePiechartLayer() {
      const stadtFilterIds = this.stadtFilterIds;
      const vue = this;
      if (!this.option || !this.option.showPiechart) {
        return;
      }

      let features = this.geoData.features.filter(f => {
        return f.properties.icon;
      });
      if (stadtFilterIds) {
        features = features.filter(f => {
          return stadtFilterIds.indexOf(f.properties.stadtindex) > -1;
        });
      }

      const source = {
        type: "FeatureCollection",
        features: features
      };
      this.piechartLayer.setSource(
        new VectorSource({
          features: new FormatGeojson().readFeatures(source, {
            featureProjection: "EPSG:3857"
          })
        })
      );
      setTimeout(function() {
        vue.map.updateSize();
      }, 50);
    },

    updateCityLayer() {
      const featureMap = new Map();
      const merzgebitFeatures = this.filterMerzgebieteGeoData.features
        .filter(f => f.show === true)
        .forEach(f => {
          featureMap.set(f.properties.id, {
            geometry: f.geometry,
            properties: {
              stadtindex: f.properties.id,
              stadtname: f.properties.name
            },
            type: "Feature"
          });
        });
      this.geoData.features.forEach(f => {
        featureMap.set(f.properties.stadtindex, {
          geometry: f.geometry,
          properties: {
            stadtindex: f.properties.stadtindex,
            stadtname: f.properties.stadtname
          },
          type: "Feature"
        });
      });
      // const features= this.geoData.features.map(f => {
      //     return {
      //       geometry: f.geometry,
      //       properties: {
      //         stadtindex: f.properties.stadtindex,
      //         stadtname: f.properties.stadtname
      //       },
      //       type: "Feature"
      //     };
      //   });
      const source = {
        type: "FeatureCollection",
        features: [...featureMap.values()]
      };

      this.cityLayer.setSource(
        new VectorSource({
          features: new FormatGeojson().readFeatures(source, {
            featureProjection: "EPSG:3857"
          })
        })
      );
    },

    updateMerzgebieteLayer() {
      const source = {
        type: "FeatureCollection",
        features: this.filterMerzgebieteGeoData.features.filter(f => f.show)
      };
      this.merzgebieteLayer.setSource(
        new VectorSource({
          features: new FormatGeojson().readFeatures(source, {
            featureProjection: "EPSG:3857"
          })
        })
      );
      this.updateCityLayer();
    },

    fensterToTop(item) {
      const vue = this;
      const infobox = item.overlay.getElement();
      const zIndex = ++this.fensterZIndex;
      const overlayContainer = infobox.parentNode;
      overlayContainer.style.zIndex = zIndex;
      item.zIndex = zIndex;
    }
  },
  computed: {
    ...mapGetters({
      fensterDataCollection: ["orteundwege/fensterDataCollection"],
      sidebarRightList: ["orteundwege/sidebarRightList"],
      activeInfoItem: ["orteundwege/activeInfoItem"],
      filterMerzgebieteGeoData: ["orteundwege/filterMerzgebieteGeoData"]
    }),
    timelineViewInput() {
      if (!this.sidebarRightList) {
        return;
      }
      const out = [];
      this.sidebarRightList
        .filter(it => it.id === "holland" || it.id === "merzabende")
        .forEach(it => {
          it.infoItems.forEach(info => {
            out.push(info);
          });
        });
      out.sort((a, b) => {
        a = a.row.datvon;
        b = b.row.datvon;
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      });
      return out;
    }
  }
};
</script>

<style lang="scss">
.ksm-map__wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  border: 2px solid #fff;
}

.ksm-map__controls {
  top: 10px;
  right: 0.5em;
  width: 30px;
  position: absolute;
}

.ksm-map__control-btn {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  svg {
    * {
      fill: #44707a;
    }
    &:hover {
      * {
        fill: $blue1;
      }
    }
  }
}

.ol-touch .ksm-map__controls {
  top: 80px;
  width: 30px;
  height: 70px;
}

.ksm-map__page {
  @extend .ksm-flex-1;
  position: relative;
}
.ksm-map__container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.ksm-map__arc text {
  font: 10px sans-serif;
  text-anchor: middle;
}

.ksm-map__arc path {
  stroke: #fff;
}

.ksm-map__fenster {
  background-color: #eee;
  border: 2px solid $darkGrey;
  // z-index: 100;
  // position: absolute;
  min-width: 100px;
  min-height: 50px;
  max-width: 300px;
  max-height: 400px;
  font-size: 9pt;
  line-height: 1.5em;
  border-radius: 5px;
  -webkit-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  @extend .ksm-flex-column;
  @extend .ksm-disable-select;
}

.ksm-display-none {
  display: none;
}

.ksm-map__fenster-header {
  @extend .ksm-flex__content--justify;
}

.ksm-map__fenster-header-arror {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.ksm-map__fenster-title {
  @extend .ksm-flex-y-center;
  padding: 0px 10px;
  font-weight: bold;
}

.ksm-map__fenster-body {
  // @extend .ksm-flex-column;
  padding: 0 5px;
  max-height: 500px;
  overflow: auto;
}

.ksm-map__fenster-item {
  @extend .ksm-flex-y-center;
}

.ksm-map__fenster-item-icon {
  width: 10px;
  border-radius: 5px;
  margin: 0px 5px;
  height: 10px;
}

.ksm-map__fenster-close {
  cursor: pointer;
  border: 1px solid $darkGrey;
  border-top: 0px;
  width: 15px;
  height: 15px;
  padding: 0;

  @extend .ksm-flex-xy-center;

  &:hover {
    border-color: #fff;
  }
}
.ksm-map__timeline-wrapper {
  position: absolute;
  bottom: 2px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// MapView.vue?69d5ef8f